import BaseApi from './baseApi';
import IAuthentication from '../models/IAuthentication';
import ICompaniesLicence from '../models/ICompaniesLicence';
import { EMPTY_GUID } from '../../config/constants';
export default class CompaniesLicensesApi extends BaseApi {
    idUser : string = "";
    constructor() {
        super("dataaccess", "dashboard");
        let userFromStorage : IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
        this.idUser = userFromStorage.idPerson;
    }

    async GetLicenceByIdCompany(idCompany: string) : Promise<ICompaniesLicence[]> {
        let json : string = "";
        if (idCompany === EMPTY_GUID) {
            json = this.getJsonReadWithIdCompany(EMPTY_GUID);
        } else {
            json = this.getJsonReadWithIdCompany(idCompany);
        }
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var company: ICompaniesLicence[] = [];
            company = response.data as ICompaniesLicence[];
            return company;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    private getJsonReadWithIdCompany(idCompany: string) : any {
        const json = {
            "fields": [{
                "Item1": "CompaniesLicenses",
                "Item2": "idCompany"
            }, {
                "Item1": "CompaniesLicenses",
                "Item2": "formName"
            }],
            "tables": [{
                "Item1": "CompaniesLicenses"
            }],
            "conditions": [{
                "Item1": "CompaniesLicenses",
                "Item2": "idCompany",
                "Item3": "=",
                "Item4": idCompany
            }]
        };
        return json;
    }
}
